import { useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import { handleError } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.helpers';
import { Throttle } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';
import { GET_THROTTLE_BY_UUID } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/scenes/ThrottleSelection/ThrotttleSelection.queries';
import {
  dropdownOptions,
  defaultOptions,
} from 'components/FormSelect/FormSelect.helpers';

type ThrottleQueryResponse = {
  throttleByUuid: Throttle;
};

export const useThrottle = () => {
  const initialThrottleOptions = dropdownOptions('Throttle', 'Select Throttle');
  const [throttleOptions, setThrottleOptions] = useState(
    initialThrottleOptions,
  );
  const [throttle, setThrottle] = useState<Throttle>();

  const handleThrottleByUuidResponse = ({
    throttleByUuid,
  }: ThrottleQueryResponse) => {
    const throttleDetailsCopy = initialThrottleOptions;
    throttleDetailsCopy.options = [defaultOptions];
    throttleDetailsCopy.options.push({
      key: throttleByUuid.uuid,
      value: throttleByUuid.uuid,
      text: throttleByUuid.name,
    });
    setThrottleOptions(throttleDetailsCopy);
    setThrottle(throttleByUuid);
  };

  const [
    getThrottleByUuid,
    { loading: getThrottleByUuidLoading },
  ] = useLazyQuery<ThrottleQueryResponse>(GET_THROTTLE_BY_UUID, {
    onError: handleError,
    onCompleted: handleThrottleByUuidResponse,
  });

  return {
    getThrottleByUuid,
    throttleOptions,
    throttle,
    getThrottleByUuidLoading,
  };
};
